import { MenuItem } from "@mui/material";
import { forwardRef } from "react";
import { ConditionTageBaseOperatorDropdown } from "~/components/ConditionBuilder/ConditionTagOperatorDropdown/ConditionTageBaseOperatorDropdown";
import { OperatorType } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/types";
import { useRiskFactorsConditionTagOperatorDropdown } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionTagOperator/ConditionTagOperatorDropdown/hooks/useRiskFactorsConditionTagOperatorDropdown";

type Props = {
  type: OperatorType;
  defaultValue?: string | undefined;
  isReadonly: boolean;
};

export const RiskFactorsConditionTagOperatorDropdown = forwardRef(
  ({ type, defaultValue, isReadonly, ...rest }: Props, _ref) => {
    const { operators, operatorsLabelMap } =
      useRiskFactorsConditionTagOperatorDropdown({
        type,
      });

    return (
      <ConditionTageBaseOperatorDropdown
        defaultValue={defaultValue}
        isReadonly={isReadonly}
        renderContent={() =>
          operators.map((operator) => (
            <MenuItem key={operator} value={operator}>
              {operatorsLabelMap[operator]}
            </MenuItem>
          ))
        }
        {...rest}
      />
    );
  },
);
